<template>
    <div class="outer-tier-container">
        <div>
            <div
                v-if="
                    tiers_settings.enabled && (saveButton || tiers.length > 0)
                "
                class="d-flex flex-row justify-space-around"
            >
                <v-toolbar flat class="mb-4 d-flex flex-row">
                    <v-btn
                    
                        color="secondary"
                        class="text-capitalize px-5"
                        depressed
                        :loading="loading || tiersLoading"
                        :disabled="!saveButton || !getPermission('point_packages.update')"
                        @click="saveChanges"
                        >{{ translations.saveChanges[lang] }}</v-btn
                    >

                    <v-btn
                        color="secondary"
                        class="text-capitalize px-5 ml-4"
                        :loading="loading || tiersLoading"
                        depressed
                        :disabled="!saveButton"
                        @click="resetChanges"
                        >{{ translations.resetChanges[lang] }}</v-btn
                    >
                </v-toolbar>
                <v-toolbar flat class="mb-4 d-flex flex-row justify-end">
                    <v-btn
                        color="error"
                        class="text-capitalize px-5"
                        :loading="loading || tiersLoading"
                        depressed
                        :disabled="!tiers.length || !getPermission('point_packages.delete')"
                        @click="deleteTiersAlert"
                        >{{ translations.deleteTiers[lang] }}</v-btn
                    >
                </v-toolbar>
            </div>
            <v-toolbar
                v-if="
                    (!saveButton && tiers.length === 0) ||
                        tiers_settings.enabled === false
                "
                flat
                class="mb-4"
            >
                <v-btn
                    color="secondary"
                    class="text-capitalize px-5 mr-4"
                    :loading="loading || tiersLoading"
                    depressed
                    :disabled="tiers.length > 9 || !tiers_settings.enabled || !getPermission('point_packages.create')"
                    @click="createTiers"
                    >{{ translations.createPointTiers[lang] }}</v-btn
                >
            </v-toolbar>
            <v-toolbar v-else flat class="mb-4 d-flex justify-center">
                <v-btn
                    color="white"
                    class="text-capitalize px-5 mr-1 round-icon-btn"
                    depressed
                    :disabled="tiers.length > 9"
                    @click="addTier"
                >
                    <v-icon
                        :size="48"
                        color="secondary"
                        v-text="icons.mdiPlusCircle"
                    ></v-icon>
                </v-btn>
                <v-btn
                    color="white"
                    class="text-capitalize px-5 ml-1 round-icon-btn"
                    depressed
                    :disabled="tiers.length <= 2"
                    @click="removeTier"
                >
                    <v-icon
                        :size="48"
                        color="secondary"
                        v-text="icons.mdiMinusCircle"
                    ></v-icon>
                </v-btn>
            </v-toolbar>
        </div>

        <div v-if="tiers_settings.enabled === false">
            <v-alert color="orange" type="warning" dismissible dense outlined>
                {{ translations.enableTierCreationAlert[lang] }}</v-alert
            >
        </div>
        <div
            v-else-if="tierValues && tierValues.length > 1"
            style="width:100%;padding: 50px 20px;"
            class="d-flex flex-row tiers-container"
            :style="{ 'min-width': `${this.$props.tiers.length * 400}px` }"
        >
            <div
                v-for="(tier, i) in tierValues"
                :key="tier.key"
                class="tier-container d-flex flex-column"
                :style="{
                    width: tier.width
                }"
            >
                <div
                    style="width:100%;display: flex;justify-content: center;padding: 0 8px;"
                    :style="{ visibility: i % 2 === 0 ? 'visible' : 'hidden' }"
                >
                    <span
                        class="text-capitalize px-5 text-subtitle-2 d-flex justify-center align-center tier-title"
                        @click="editTierDialog(tiers[i], i)">{{ tier.title[lang] }}</span
                    >
                    <span style="position: relative;">
                        <v-tooltip color="secondary" top>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    style="position: absolute; right: 46px;"
                                    color="white darken-3"
                                    class="mr-1"
                                    icon
                                    v-on="on"
                                    @click="editTierDialog(tiers[i], i)"
                                >
                                    <v-icon
                                        v-text="icons.mdiPencilOutline"
                                    ></v-icon>
                                </v-btn>
                            </template>
                            <span class="font-weight-bold">{{ translations.edit[lang] }}</span>
                        </v-tooltip>
                    </span>
                </div>
                <div
                    class="d-flex flex-column "
                    :style="{
                        width: `100%`,
                        'padding-top': `25px`,
                        position: 'relative'
                    }"
                >
                    <!-- {{ tier.errors }} -->
                    <div
                        v-if="tier.errors && tier.errors.length"
                        class="d-flex flex-column ml-2 pt-2"
                        style="width:95%;display: flex;justify-content: center;padding: 0 8px; position: absolute; bottom: 60px; "
                        :style="{
                            visibility: i % 2 === 1 ? 'visible' : 'hidden'
                        }"
                    >
                        <v-col
                            cols="12"
                            md="12"
                            class="d-flex pt-0 justify-center pl-10"
                            v-for="(tierError, errorI) in tier.errors"
                            :key="errorI"
                        >
                            <span style="color: rgb(199, 28, 28);">
                                {{ tierError }}
                            </span>
                        </v-col>
                        <v-icon
                            style="position: absolute; left: 45%; bottom: -30px;"
                            v-text="icons.mdiArrowUpBold"
                            size="40"
                            :color="tier.color"
                        ></v-icon>
                        <v-icon
                            style="position: absolute; left: 45%; color: rgb(227, 39, 39); bottom: -96px; cursor: pointer;"
                            v-text="icons.mdiAlert"
                            size="40"
                            @click="editTierDialog(tiers[i], i)"
                        ></v-icon>
                    </div>
                    <v-range-slider
                        :style="{
                            padding: 0,
                            margin: 0
                        }"
                        @change="handleTierChange(i)"
                        v-model="tiers[i].pointRange"
                        :max="tiers[i].pointRange[1]"
                        :min="tiers[i].pointRange[0]"
                        :tick-size="1"
                        :step="
                            Math.min(
                                10 **
                                    (Math.max((tiers[i].to + '').length, 2) -
                                        2),
                                100
                            )
                        "
                        :color="tier.color"
                        :track-color="tier.color"
                        :track-fill-color="tier.color"
                        :thumb-color="tier.color"
                        :thumb-size="
                            Math.max(
                                tiers[i].pointRange[1].toString().length,
                                5
                            ) * 15
                        "
                        thumb-label="always"
                        :id="tier.key"
                        :class="{
                            reverseLabel: i % 2 === 1,
                            regularLabel: i % 2 === 0
                        }"
                    >
                        <template v-slot:thumb-label="e">
                            <v-icon
                                v-if="
                                    i == tiers.length - 1 &&
                                        e.value >=
                                            tiers[i].to - tiers[i].to * 0.006
                                "
                                class="b-social-icon"
                                color="white"
                                :size="
                                    Math.max(
                                        tiers[tiers.length - 1].from.toString()
                                            .length,
                                        5
                                    ) * 6
                                "
                                dense
                                v-text="icons.mdiInfinity"
                            ></v-icon>
                            <span
                                v-else
                                @click="labelClick"
                                class="labeltext"
                                :style="{
                                    'font-size': `${Math.max(
                                        tiers[i].pointRange[1].toString()
                                            .length,
                                        5
                                    ) * 3}px`
                                }"
                                >{{ e.value }}
                            </span>
                        </template>
                    </v-range-slider>
                    <div
                        v-if="tier.errors && tier.errors.length"
                        class="d-flex flex-column ml-2 pt-2"
                        style="width:95%;display: flex;justify-content: center;padding: 0 8px; position: absolute; top: 80px;"
                        :style="{
                            visibility: i % 2 === 0 ? 'visible' : 'hidden'
                        }"
                    >
                        <v-col
                            cols="12"
                            md="12"
                            class="d-flex pt-0 justify-center pl-10"
                            v-for="(tierError, errorI) in tier.errors"
                            :key="errorI"
                        >
                            <span style="color: rgb(199, 28, 28);">
                                {{ tierError }}
                            </span>
                        </v-col>
                        <v-icon
                            style="position: absolute; left: 45%; top: -45px;"
                            v-text="icons.mdiArrowDownBold"
                            size="40"
                            :color="tier.color"
                        ></v-icon>
                        <v-icon
                            style="position: absolute; left: 45%; color: rgb(227, 39, 39); top: -118px; cursor: pointer;"
                            v-text="icons.mdiAlert"
                            size="40"
                            @click="editTierDialog(tiers[i], i)"
                        ></v-icon>
                    </div>
                </div>
                <div
                    style="width:100%;display: flex;justify-content: center;padding: 0 8px;"
                    :style="{ visibility: i % 2 === 1 ? 'visible' : 'hidden' }"
                >
                    <span 
                        class="text-capitalize px-5 text-subtitle-2 d-flex justify-center align-center tier-title"
                        @click="editTierDialog(tiers[i], i)" >{{ tier.title[lang] }}</span
                    >
                    <span style="position: relative;">
                        <v-tooltip color="secondary" top>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    style="position: absolute; right: 46px;"
                                    color="white darken-3"
                                    class="mr-1"
                                    icon
                                    v-on="on"
                                    @click="editTierDialog(tiers[i], i)"
                                >
                                    <v-icon
                                        v-text="icons.mdiPencilOutline"
                                    ></v-icon>
                                </v-btn>
                            </template>
                            <span class="font-weight-bold">{{ translations.edit[lang] }}</span>
                        </v-tooltip>
                    </span>
                </div>
            </div>

            <v-dialog
                v-model="editDialog"
                :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '40%'"
                :persistent="!tierValid"
            >
                <PointTierForm
                    @close="editDialog = false"
                    @submit="submitTierForm"
                    :tier="editTier"
                    :tierIndex="editTierIndex"
                    :infinity-multiplier="infinityMultiplier"
                />
            </v-dialog>
            <v-dialog
                v-model="saveDialog"
                :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '40%'"
            >
                <PointTierAlertDialog
                    @close="saveDialog = false"
                    @submit="savePointTiers"
                    :alert-text="this.translations.confirmSaveMsg[this.lang]"
                />
            </v-dialog>
            <v-dialog
                v-model="deleteDialog"
                :max-width="$vuetify.breakpoint.smAndDown ? '90%' : '40%'"
            >
                <PointTierAlertDialog
                    @submit="deleteAllTiers"
                    @close="deleteDialog = false"
                    :alert-text="
                        this.translations.confirmDeleteTiers[this.lang]
                    "
                />
            </v-dialog>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/pointTitles";
import validators from "@/utils/validators/loyaltyPanel/pointTiers";
import PointTierForm from "./PointTierForm";
import PointTierAlertDialog from "./PointTierAlertDialog";
import {
    mdiInfinity,
    mdiPlusCircle,
    mdiMinusCircle,
    mdiPencilOutline,
    mdiAlert,
    mdiArrowUpBold,
    mdiArrowDownBold
} from "@mdi/js";
import { cloneDeep } from "lodash";

export default {
    name: "PointTiers",

    components: { PointTierForm, PointTierAlertDialog },
    mixins: [translations, validators],

    props: {
        tiers: {
            type: Array,
            default: new Array()
        }
    },

    data() {
        return {
            icons: {
                mdiInfinity,
                mdiPlusCircle,
                mdiMinusCircle,
                mdiPencilOutline,
                mdiAlert,
                mdiArrowUpBold,
                mdiArrowDownBold
            },
            titleLang: this.$route.params.lang,
            descLang: this.$route.params.lang,
            editDialog: false,
            saveButton: false,
            saveDialog: false,
            deleteDialog: false,
            tierPointChanged: false,
            savedTiers: [],
            // resetButton: false,
            editTier: {},
            editTierIndex: null,
            tiersAreNewlyCreated: false,
            tiersAreDeleted: false,
            dialogPersistent: false,
            tierData: {},
            tierIndex: -1
        };
    },
    async mounted() {
        await this.fetchPointTitles();
        this.$nextTick(() => {
            this.savedTiers = JSON.parse(JSON.stringify(this.$props.tiers));
            this.saveButton = false;
            // this.resetButton = false;
            this.tierPointChanged = false;
        });
    },
    computed: {
        ...mapState("loyaltyPanel/pointTitles", ["tiersLoading", "tierValid"]),
        ...mapState("loyaltyPanel", ["tiers_settings"]),
        ...mapState(["loading", "errorMessage"]),
        infinityMultiplier() {
            return (
                (this.$props.tiers.length &&
                    Math.max(1 + 1 / this.$props.tiers.length, 1.1)) ||
                2
            );
        },
        tierValues: {
            get() {
                let vals =
                    this.$props.tiers &&
                    this.$props.tiers.map((e, i, a) => {
                        if (a.length > 0) {
                            let from = (e.from = e.from || 0);
                            if (i === a.length - 1) {
                                if (!e.to)
                                    e.to = parseInt(
                                        ((from * this.infinityMultiplier) /
                                            100) *
                                            100
                                    );
                                if (e.pointRange) e.pointRange[1] = e.to;
                            }
                            let to = e.to;
                            let key =
                                e.title[this.lang] +
                                e.color +
                                (e.from || 0) +
                                (e.to || 0);

                            if (e.pointRange) {
                                key =
                                    e.title[this.lang] + e.color + e.pointRange;
                                if (e.pointRange[0] === e.pointRange[1]) {
                                    e.pointRange = [from, to];
                                }
                            } else {
                                e.pointRange = [e.from, e.to];
                            }
                            e.expiration_days =
                                (this.tiers_settings.system !==
                                    "expiration_mode" &&
                                    undefined) ||
                                e.expiration_days;
                            key += e.expiration_days;
                            let lastLimit = a[a.length - 1].to;
                            let tierPoints = to - from;
                            let width =
                                (lastLimit &&
                                    `${Math.round(
                                        (tierPoints * 100) / lastLimit
                                    )}%`) ||
                                "50%";

                            return {
                                ...e,
                                from,
                                to,
                                key,
                                tierPoints,
                                lastLimit,
                                width
                            };
                        }
                        return e;
                    });
                return vals;
            },
            set(val) {
                this.setTiers(val);
            }
        },
        lang() {
            return this.$route.params.lang;
        },

        title() {
            return this.mode === 1
                ? this.translations.addPointPackage[this.lang]
                : this.translations.updatePointPackage[this.lang];
        },

        pointTitle: {
            get() {
                return this.$store.state.loyaltyPanel.pointTitles.pointTitle;
            },
            set(val) {
                this.setPointTitle(val);
            }
        }
    },
    watch: {
        tiers: {
            handler(val, oldVal) {
                this.$nextTick(() => {
                    if (
                        !this.tiersAreNewlyCreated &&
                        (!this.savedTiers.length ||
                            !val[0].pointRange ||
                            JSON.stringify(val) ===
                                JSON.stringify(this.savedTiers))
                    ) {
                        this.saveButton = false;
                        this.tierPointChanged = false;
                    } else {
                        this.saveButton = true;
                        if (this.savedTiers.length !== val.length) {
                            this.tierPointChanged = true;
                        }
                        val.forEach((e, i) => {
                            if (
                                !this.savedTiers[i] ||
                                e.from !== this.savedTiers[i].from ||
                                e.to !== this.savedTiers[i].to
                            ) {
                                this.tierPointChanged = true;
                            }
                        });
                    }
                });
            },
            deep: true
        },

        ["tiers.length"]: {
            async handler(val, oldVal) {
                if (val) {
                    await this.$nextTick(async () => {
                        this.getTiersErrors();
                    });
                }
            },
            deep: true
        },

        ["editDialog"]: {
            async handler(val, oldVal) {
                await this.$nextTick(async () => {
                    this.getTiersErrors();
                });
            },
            deep: true
        }
    },

    methods: {
        ...mapActions("loyaltyPanel/pointTitles", [
            "create",
            "update",
            "fetchPointTitles",
            "remove"
        ]),
        ...mapMutations("loyaltyPanel/pointTitles", ["setTiers"]),
        ...mapMutations(["setNotification"]),
        ...mapActions(["getPermission"]),
        labelClick() {},
        removeTier() {
            this.$props.tiers.pop();
            if (this.$props.tiers.length === 1) this.$props.tiers.pop();
        },
        deleteTiersAlert() {
            this.deleteDialog = true;
        },
        resetChanges() {
            this.setTiers(JSON.parse(JSON.stringify(this.savedTiers)));
            this.saveButton = true;
        },
        getTiersErrors() {
            let errors = [];
            for (let [i, tier] of this.tiers.entries()) {
                this.tierData = tier;
                this.tierIndex = i;
                this.validateTierForm();
                tier.errors = Object.values(cloneDeep(this.error)).filter(
                    e => !!e
                );
            }
            return errors;
        },
        async saveChanges() {
            if (this.tiers?.[0]?.["expiration_days"]) {
                this.tiers[0]["expiration_days"] = undefined;
            }
          
            if (this.tierPointChanged) {
                return (this.saveDialog = true);
            }
            let res = {};
            if (this.tiersAreNewlyCreated) {
                res = await this.create();
            } else {
                res = await this.update();
            }
            if (res && !res.error) {
                this.$nextTick(() => {
                    this.saveButton = false;
                    this.savedTiers = JSON.parse(
                        JSON.stringify(this.$props.tiers)
                    );
                    this.tiersAreNewlyCreated = false;
                });
            }
        },

        async savePointTiers() {
            if (this.tiers?.[0]?.["expiration_days"]) {
                this.tiers[0]["expiration_days"] = undefined;
            }
            let res = {};
            if (this.tiersAreNewlyCreated) {
                res = await this.create();
            } else {
                res = await this.update();
            }
            this.saveDialog = false;
            if (res && !res.error) {
                this.$nextTick(() => {
                    this.saveButton = false;
                    this.savedTiers = JSON.parse(
                        JSON.stringify(this.$props.tiers)
                    );
                    this.tiersAreNewlyCreated = false;
                });
            } else if (
                res &&
                res.message ==
                    "System currently maps users to newly updated packages. Please try again later."
            ) {
                let errorText = {
                    en: res.message,
                    el:
                        "Το σύστημα αντιστοιχίζει προς το παρόν τους χρήστες σε πρόσφατα ενημερωμένα πακέτα. Προσπαθήστε ξανά αργότερα.",
                    it:
                        "Il sistema attualmente mappa gli utenti verso i pacchetti appena aggiornati. Riprovare più tardi."
                };
                this.setNotification({
                    show: true,
                    type: "error",
                    text: errorText[this.lang]
                });
            } else if (
                res &&
                res.message.includes(
                    "expiration days has to be greater than zero"
                )
            ) {
                let errorText = {
                    en:
                        "Expiration days has to be greater than zero (0) in expiration mode",
                    el:
                        "Οι ημέρες λήξεως πρέπει να είναι μεγαλύτερες από το μηδέν (0) στη λειτουργία με χρόνο λήξης.",
                    it:
                        "I giorni di scadenza devono essere maggiori di zero (0) in modalità di scadenza."
                };
                this.setNotification({
                    show: true,
                    type: "error",
                    text: errorText[this.lang]
                });
            }
        },

        async deleteAllTiers() {
            await this.remove();
            this.saveButton = false;
            this.deleteDialog = false;
            this.tiersAreNewlyCreated = true;
        },

        createTiers() {
            this.setTiers([
                {
                    title: {
                        en: "",
                        el: "",
                        it: ""
                    },
                    description: {
                        en: "",
                        el: "",
                        it: ""
                    },
                    color:
                        "#" +
                        ((Math.random() * 0xffffff) << 0)
                            .toString(16)
                            .padStart(6, "0"),
                    from: 0,
                    to: 10000
                },
                {
                    title: {
                        en: "",
                        el: "",
                        it: ""
                    },
                    description: {
                        en: "",
                        el: "",
                        it: ""
                    },
                    from: 10001,
                    to: 20000,
                    expiration_days:
                        this.tiers_settings.system === "expiration_mode"
                            ? -1
                            : undefined,
                    color:
                        "#" +
                        ((Math.random() * 0xffffff) << 0)
                            .toString(16)
                            .padStart(6, "0")
                }
            ]);

            if (!this.savedTiers.length || this.tiersAreDeleted) {
                this.tiersAreNewlyCreated = true;
            }
        },

        addTier() {
            let newTier = {
                title: {
                    en: "",
                    el: "",
                    it: ""
                },
                description: {
                    en: "",
                    el: "",
                    it: ""
                },
                color:
                    "#" +
                    ((Math.random() * 0xffffff) << 0)
                        .toString(16)
                        .padStart(6, "0"),
                from: 0,
                to: 10000,
                expiration_days:
                    this.tiers_settings.system === "expiration_mode"
                        ? -1
                        : undefined
            };
            if (this.$props.tiers && this.$props.tiers.length) {
                (newTier.from =
                    this.$props.tiers[this.$props.tiers.length - 1].to + 1),
                    (newTier.to =
                        parseInt(
                            (newTier.from * this.infinityMultiplier) / 100
                        ) * 100);
                this.$props.tiers.push(newTier);
            } else {
                this.setTiers([
                    newTier,
                    {
                        title: {
                            en: "",
                            el: "",
                            it: ""
                        },
                        description: {
                            en: "",
                            el: "",
                            it: ""
                        },
                        from: newTier.to + 1,
                        to:
                            parseInt(
                                (newTier.to * this.infinityMultiplier) / 100
                            ) * 100,
                        expiration_days:
                            this.tiers_settings.system === "expiration_mode"
                                ? -1
                                : undefined,
                        color:
                            "#" +
                            ((Math.random() * 0xffffff) << 0)
                                .toString(16)
                                .padStart(6, "0")
                    }
                ]);
            }
        },
        editTierDialog(tier, i) {
            this.editTier = tier;
            this.editTierIndex = i;
            this.editDialog = true;
        },
        handleTierChange(i) {
            let tier = this.$props.tiers[i];
            let nextTier = this.$props.tiers[i + 1];
            let prevTier = this.$props.tiers[i - 1];
            tier.to = (tier.pointRange && tier.pointRange[1]) || tier.to;
            tier.from = (tier.pointRange && tier.pointRange[0]) || tier.from;
            if (prevTier) {
                prevTier.to = tier.from - 1;
                if (prevTier.pointRange) prevTier.pointRange[1] = tier.from - 1;
            } else {
                tier.from = 0;
                tier.pointRange[0] = tier.from;
            }
            if (nextTier) {
                nextTier.from = tier.to + 1;
                if (nextTier.pointRange) nextTier.pointRange[0] = tier.to + 1;
            } else {
                tier.to = parseInt(tier.from * this.infinityMultiplier);
                tier.pointRange[1] = tier.to;
            }
        },
        submitTierForm(tier, i) {
            this.$set(this.tiers, i, tier);
            if (this.tierValid) {
                this.editDialog = false;
            }
        }
    }
};
</script>

<style scoped>
.tier-title {
    background-color: #2a3042;
    min-height: 36px;
    width: 100% !important;
    color: white;
    cursor: pointer;
}
.tier-container {
    min-width: 250px;
    padding-bottom: 100px;
}
.tiers-container * {
    width: auto;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    transition: all 0.5s ease-in-out;
}
.reverseLabel .labeltext {
    transform: scale(-1, -1);
    display: inline-block;
}
.tier-description {
    position: absolute;
    margin-top: -25px;
}
.round-icon-btn {
    padding: 0px !important;
    min-height: 52px !important;
    border-radius: 33px;
    min-width: 52px !important;
}
</style>
<style>
.reverseLabel .v-slider__thumb-label {
    transform: translateY(100%) translateY(30%) translateX(-50%) rotate(225deg) !important;
}

.v-slider__thumb-label {
    z-index: 2;
}

.reverseLabel .v-slider--horizontal {
    margin-left: 5px !important;
    margin-right: 5px !important;
}
</style>
